import { makeAutoObservable } from "mobx";
import * as PubSub from '../pubSub';
import * as AvailabilityProvider from '../../services/availability';
import { Manager } from "../../core";

export class AvailabilityStoreMobx {
  public settings: any = {
    allowed_days: [1, 2, 3, 4, 5],
    allowed_hours: ["08:00am", "10:00am", "14:00pm", "16:00pm"],
    blocked_dates: [],
    enabled_dates: []
  };

  constructor() {
    makeAutoObservable(this);
  }

  setSettings = (settings: any) => {
    this.settings = settings;
  };

  get = async () => {
    try {
      const response: any = await AvailabilityProvider.get();
      const result = response?.data || response || this.settings;
      this.setSettings(result);
      return result;
    } catch (e) {
      throw new Manager.ServiceError('error.availabilityStore.get', e);
    }
  };

  save = async (settings: any) => {
    try {
      await AvailabilityProvider.save(settings);
      this.setSettings(settings);
    } catch (e) {
      throw new Manager.ServiceError('error.availabilityStore.save', e);
    }
  };
}

let singleton: AvailabilityStoreMobx | null = null;

export const AvailabilityStore = () => {
  if (!singleton) {
    singleton = new AvailabilityStoreMobx();

    PubSub.subscribe(PubSub.LOGOUT, () => {
      singleton = null;
    });
  }
  return singleton;
};
